import React from 'react';
import { connect } from 'react-redux';
import { Loading } from '../UI/Loading';
import { QuizListItem } from './QuizListItem';
import { updateQuizStatus, deleteQuiz } from '../../redux/actions/quizzes';
const QuizListComponent = ({ loading, quizzes, layout, deleteQuiz, updateQuizStatus, error, errorDetail, }) => {
    const handleDeleteQuiz = (quizId) => {
        deleteQuiz(quizId);
    };
    const handleStatusUpdate = (quizId, status) => {
        updateQuizStatus({ quizId, status });
    };
    return error ? (React.createElement("div", null, errorDetail)) : loading ? (React.createElement(Loading, null)) : quizzes.length < 1 ? (React.createElement("div", { style: {
            width: '70%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
        } },
        React.createElement("p", { style: { textAlign: 'center', color: 'grey' } }, "Wow, such emptiness. Why don't you create a new quiz. :)"))) : (React.createElement("div", { className: layout === 'Grid' ? 'activity-grid' : 'activity-list' }, quizzes.map((quiz) => (React.createElement(QuizListItem, { key: quiz.quizId, quiz: quiz, onDelete: handleDeleteQuiz, onStatusUpdate: handleStatusUpdate })))));
};
const mapStateToProps = (state) => ({
    loading: state.quizState.loading,
    error: state.quizState.error,
    errorDetail: state.quizState.errorDetail,
});
const mapDispatchToProps = {
    updateQuizStatus,
    deleteQuiz,
};
export const QuizList = connect(mapStateToProps, mapDispatchToProps)(QuizListComponent);
